import queryString from 'qs';

import createBatchDto from '@/features/single-measurement/dto/batch';
import { IBatch, ICreateBatch } from '@/features/single-measurement/types';
import { serializeCreateBatchesParams } from '@/features/single-measurement/utils/serialize-requests';
import { apiClient } from '@/libs/http-client';

import createFermentation from '../dto/fermentation';
import { IGetFermentations } from '../types/api';
import { IFermentation } from '../types/fermentation';
import {
  serializeCreateFermentationParams,
  serializeGetFermentationsParams,
} from '../utils/serialize-requests';

export const getFermentation = async (id: string): Promise<IFermentation> => {
  return apiClient()
    .get(`fermentation/${id}`)
    .json()
    .then((response: any) => createFermentation(response));
};

export const getFermentationBatches = async (
  id: string,
  group: string | undefined,
): Promise<IBatch[]> => {
  const groupParam = group ? `?group=${group}` : '';
  return apiClient()
    .get(`fermentation/${id}/batches${groupParam}`)
    .json()
    .then((response: any) => response.map((d: unknown) => createBatchDto(d)));
};

export const getFermentations = async (
  params: IGetFermentations,
): Promise<IFermentation[]> => {
  return apiClient()
    .get('fermentation', { searchParams: serializeGetFermentationsParams(params) })
    .json()
    .then((response: any) => response.map((d: unknown) => createFermentation(d)));
};

export const createFermentationn = (
  params: Partial<Omit<IFermentation, 'id'>>,
): Promise<IFermentation> => {
  const data = serializeCreateFermentationParams({ ...params });
  return apiClient()
    .post(`fermentation`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify(data),
    })
    .json();
};

export const addBatchToFermentation = async (
  id: string,
  data: ICreateBatch,
): Promise<IBatch> => {
  return apiClient()
    .post(`fermentation/${id}/batches`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify(serializeCreateBatchesParams(data)),
    })
    .json()
    .then((response: any) => createBatchDto(response));
};

export const setFavouriteFermentation = async (
  id: string,
  isFavourite: boolean,
): Promise<IFermentation> => {
  return apiClient()
    .put(`fermentation/${id}`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify({ is_favourite: isFavourite }),
    })
    .json();
};

export const getFavouriteFermentations = async (
  method: 'FW' | 'BB' | 'ETOH',
): Promise<IFermentation[]> => {
  return apiClient()
    .get('fermentation/favourites', {
      searchParams: { method },
    })
    .json();
};

export const updateFermentation = (
  id: string,
  params: Partial<Omit<IFermentation, 'id'>>,
): Promise<IFermentation> => {
  return apiClient()
    .put(`wine_primary/${id}`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify({ ...params }),
    })
    .json();
};
